import {axios} from "@/api/config";
// 查询检查项列表
export function listTask(params) {
  return axios.post('/tbBaseCheckTask/list', params,true);
}
export function listDangerGovern(params) {
  return axios.post('/hiddenGovern/list', params, false);
}

// 查询检查项详细
export function getItem(taskId) {
  return axios.get(`/tbBaseCheckItem/${taskId}`, taskId, true)
}

// 查询检查项详细
export function getScore(param) {
  return axios.get(`/tbBaseCheckScore/list`, param, true)
}

